import { render, staticRenderFns } from "./CenterViewShippingList_Ap.vue?vue&type=template&id=4b214a8f&scoped=true"
import script from "./CenterViewShippingList_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewShippingList_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewShippingList_Ap.vue?vue&type=style&index=0&id=4b214a8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b214a8f",
  null
  
)

export default component.exports